<div class="flexRowContainer">
  <span class="body-medium">
    {{ data.message | translate:data.messageParams }}
  </span>
  <span id="actions" matSnackBarActions>
    <button mat-icon-button (click)="snackBarRef.dismissWithAction()">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>
  </span>
</div>
